// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"CancellationAdditionalDetails_errorMessage__1jUyy"};